/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_Group_AgentInputs */

const cs_draft_group_agent = /** @type {(inputs: Draft_Group_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Makléř`)
};

const en_draft_group_agent = /** @type {(inputs: Draft_Group_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent`)
};

/**
* | output |
* | --- |
* | "Agent" |
*
* @param {Draft_Group_AgentInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const draft_group_agent = /** @type {((inputs?: Draft_Group_AgentInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Group_AgentInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_draft_group_agent(inputs)
	return cs_draft_group_agent(inputs)
});